import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import Loading from '@/components/common/loading.tsx';
import { useAuthState } from '@/lib/auth/hooks/useAuthState.ts';
import { z } from '@/lib/es-zod.ts';

export const Route = createFileRoute('/registro')({
  validateSearch: z.object({
    redirect: z.string().optional(),
  }),
  component: () => <Register />,
});

function Register() {
  const { redirect } = Route.useSearch();
  const { signup } = useAuthState();

  useEffect(() => {
    console.debug('Redirecting to signup...');

    signup({
      returnTo: redirect,
    });
  }, [redirect, signup]);

  return <Loading />;
}
